<template>
  <div id="app">
    <div class="main-body">
      <navbar></navbar>
      <div class="container-fluid">
        <router-view></router-view>  
      </div>
    </div>
  </div>
</template>

<script>
import navbar from './components/_partial/NavBar'
import {getHostName} from '@/utils/tools'

export default {
  name: 'app',
  components: {
    navbar
  },
  data () {
    return {
    }
  },
  created () {
    document.title = '生产管理-' + getHostName()
  }
}
</script>

<style lang="scss">
@import './assets/style.scss';

.main-body {
  margin: 65px 0 0 0;
}
</style>
